import { EditorData } from "./EditorData";
export default EditorData;
